import { useState, useEffect, useContext } from "react";

import {
  firestoreDatabase,
  signInUserAnonymously,
} from "../../utils/firebase-utils";
import { onSnapshot, collection, query, where } from "firebase/firestore";

import Prayer from "./prayer";
import "./prayers-container.styles.css";

import ConfirmDeleteModal from "./confirm-delete-modal";

import { PrayerModalContext } from "../../contexts/prayer-modal-context";
import SubmitPrayerForm from "./submit-prayer-form";
import { SignUpModalContext } from "../../contexts/signup-modal-context";
import SignUpForm from "../authentication/sign-up-form";
import { ForgottenPasswordContext } from "../../contexts/forgotten-password-context";
import ForgottenPasswordForm from "../forgotten-password/forgotten-password-form";
import SignInForm from "../authentication/sign-in-form";
import { SignInModalContext } from "../../contexts/signin-modal-context";
import { UnregisteredEmailContext } from "../../contexts/unregistered-email-context";
import UnregisteredEmail from "../forgotten-password/unregistered-email";
import { GuestSignUpModalContext } from "../../contexts/guest-signup-modal-context";
import GuestSignUpForm from "../authentication/guest-sign-up-form";
import { ConfirmDeleteModalContext } from "../../contexts/confirm-delete-modal-context";
import { UserContext } from "../../contexts/user-context";
import { isUserDeleted } from "../../utils/is-user-deleted";

// just under one week to clear prayers before start of Sunday a.m. service
const ONE_WEEK = 1000 * 60 * 60 * 24 * 6.9;
const NOW = new Date().getTime();
const ONE_WEEK_AGO = NOW - ONE_WEEK;

const PrayersContainer = () => {
  const [prayers, setPrayers] = useState([]);

  const { setCurrentUser } = useContext(UserContext);

  const { openSubmitPrayerModal } = useContext(PrayerModalContext);
  const { openSignInModal } = useContext(SignInModalContext);
  const { openGuestSignUpModal } = useContext(GuestSignUpModalContext);
  const { openForgottenPasswordModal, setOpenForgottenPasswordModal } =
    useContext(ForgottenPasswordContext);
  const { openUnregisteredEmailModal, setOpenUnregisteredEmailModal } =
    useContext(UnregisteredEmailContext);
  const { openConfirmDeleteModal } = useContext(ConfirmDeleteModalContext);
  const { openSignUpModal } = useContext(SignUpModalContext);

  useEffect(() => {
    fetchPrayersFromFirestoreDb();
  }, []);

  const getUser = async () => {
    const storageUser = localStorage.getItem("user");

    if (!storageUser) {
      await signInAnonymously();
    } else {
      const parsedStorageUser = JSON.parse(storageUser);

      const userCreatedMoreThanThirtyDaysAgo = isUserDeleted(
        parsedStorageUser.createdAt
      );

      if (userCreatedMoreThanThirtyDaysAgo) {
        localStorage.clear();
        await signInAnonymously();
      }
    }
  };

  const fetchPrayersFromFirestoreDb = async () => {
    await getUser();

    const allPrayersQuery = await query(
      collection(firestoreDatabase, "prayers"),
      where("createdAtTimestamp", ">", ONE_WEEK_AGO)
    );

    await onSnapshot(allPrayersQuery, (querySnapshot) => {
      const allPrayers = [];
      querySnapshot.forEach((doc) => {
        allPrayers.push(doc.data());
      });
      setPrayers(allPrayers);
    });
  };

  const setUser = (data) => {
    localStorage.setItem("user", JSON.stringify(data));
    setCurrentUser(data);
  };

  const signInAnonymously = async () => {
    try {
      const { user } = await signInUserAnonymously();
      await setUser(user);
    } catch (error) {
      alert("error");
    }
  };

  if (prayers === null)
    return (
      <section className="prayers-container">
        <h1>Prayer Requests</h1>
        <div>
          <p>No recent prayer requests. Submit one now!</p>
        </div>
      </section>
    );

  const prayersInDateOrder = prayers.sort(
    (a, b) => b.createdAtTimestamp - a.createdAtTimestamp
  );

  return (
    <>
      <section className="prayers-container">
        {prayersInDateOrder.map((prayer) => (
          <Prayer key={prayer.prayerId} prayer={prayer} />
        ))}
      </section>
      {openSubmitPrayerModal && <SubmitPrayerForm />}
      {openSignInModal && (
        <SignInForm setPasswordModal={setOpenForgottenPasswordModal} />
      )}
      {openSignUpModal && <SignUpForm />}
      {openForgottenPasswordModal && (
        <ForgottenPasswordForm
          setPasswordModal={setOpenForgottenPasswordModal}
          setUnregisteredModal={setOpenUnregisteredEmailModal}
        />
      )}
      {openUnregisteredEmailModal && <UnregisteredEmail />}
      {openGuestSignUpModal && <GuestSignUpForm />}
      {openConfirmDeleteModal && <ConfirmDeleteModal />}
    </>
  );
};

export default PrayersContainer;
